module.exports = __webpack_public_path__ + "static/juliana_guterres-2425a6818ed167721109afab8d0d66e9.png";